<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp" id="ded"> </p>
<p class="Dedication-ded"><span epub:type="pagebreak" id="pg_5" title="5">TO MOM</span></p>
<p class="Dedication-ded-l"><span class="ePub-I">I once again want to show you a craft that I’ve made.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?162dc048